module.exports = __webpack_public_path__ + "img/2x.d2065a5.jpg";